document.addEventListener('DOMContentLoaded', function () {

    const elements = document.querySelectorAll('.add-smiley');

    if (elements !== null) {
        for (const element of elements) {
            element.addEventListener('click', (event) => {

                const smiley = element.getAttribute('data-text');
                const textarea = document.querySelector('.smiley-textarea');
                const [cursorPositionStart, cursorPositionEnd, textareaValue]  = [textarea.selectionStart, textarea.selectionEnd, textarea.value];

                const insertNewTextarea = (cursorStart, cursorEnd, text, smiley) => {
                    textarea.value = text.slice(0, cursorStart) + smiley + text.slice(cursorEnd) + ' ';
                }

                if (textarea) {
                    insertNewTextarea(cursorPositionStart, cursorPositionEnd, textareaValue, smiley);
                    textarea.focus()
                }
            })

        }
    }
})
